import { ENCODING_VALIDATION_MESSAGE } from '@assetManagement/data/uploadVideoValidationMessage';
import videoFileProcessor from './videoFileProcessor';

function findValidCodec(value, codecList) {
  /* Sample codec values 
    1. video -> "avc1.42c00d", 
    2. audio -> "mp4a.40.2" 
  */
  const videoCodec = value?.split('.')[0];
  if (videoCodec && codecList.includes(videoCodec)) {
    return true;
  }
  return false;
}

export const isValidEncodedVideo = async (file, videoCodecConfig) => {
  const fileInfo = await videoFileProcessor(file);
  const videoCodecName = fileInfo?.videoTracks[0]?.codec;

  if (videoCodecName) {
    if (findValidCodec(videoCodecName, videoCodecConfig.codecs)) {
      return ENCODING_VALIDATION_MESSAGE.encoded;
    } else {
      return `${ENCODING_VALIDATION_MESSAGE.invalidVideoCodec} ${videoCodecConfig.name}`;
    }
  } else {
    return ENCODING_VALIDATION_MESSAGE.videoStreamNotAvailable;
  }
};

export const isValidEncodedAudio = async (file, audioCodecConfig) => {
  const fileInfo = await videoFileProcessor(file);
  const audioCodecName = fileInfo?.audioTracks[0]?.codec;

  if (!audioCodecName) {
    return ENCODING_VALIDATION_MESSAGE.audioStreamNotAvailable;
  }

  if (findValidCodec(audioCodecName, audioCodecConfig.codecs)) {
    return ENCODING_VALIDATION_MESSAGE.encoded;
  } else {
    return `${ENCODING_VALIDATION_MESSAGE.invalidAudioCodec} ${audioCodecConfig.name}`;
  }
};
